import React,{useState,useEffect} from 'react'
import './style.css'
import Logo from 'assets/image/logo-qubisa.png'
import Check from 'assets/icon/Check.png'
import { useDispatch,useSelector } from 'react-redux'
import { getForumSelection,postForumSelection } from 'redux/actions/forum'
import { setReducer } from 'redux/actions/reducer'
import { CircularProgress } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';

export default function Topic(props) {
    const dispatch = useDispatch()
    const persist = useSelector(state => state.persist)
    const reducer = useSelector(state => state.reducer)
    const general = useSelector(state => state.general)
    const {firstvisit_topic}=persist
    const {forum_selection}=reducer
    // console.log(`firstvisit_topic`, firstvisit_topic)
    useEffect(() => {
        dispatch(getForumSelection(firstvisit_topic))
    }, [])
    const selectSelection=(i1,i2)=>{
        forum_selection[i1].forums[i2].isSelected=!forum_selection[i1].forums[i2].isSelected
        dispatch(setReducer({forum_selection:forum_selection}))
    }
    const onLanjut=()=>{
        let new_s=[]
        forum_selection.map((forum)=>{
            forum.forums.map((dat)=>{
                if(dat.isSelected){
                    new_s.push(dat.forum.forumId)
                }
            })
        })
        let data={
            userId:props.profile.id,
            selections:new_s
        }
        dispatch(postForumSelection(data))
    }
    return (
        <div>
            <div className='layout-container-topic'>
                {firstvisit_topic&&<div className='greeting-text'>
                    <h1 className="font-roboto ">👋 Hi selamat berabung di forum &nbsp;<img className='topic-logo' src={Logo}/></h1>
                </div>}
                <br/>
                {general.isLoadingTable?
                    <div className='digital-section' >
                        <Skeleton animation="wave" height={60} width="50%" />
                        <Skeleton animation="wave" height={40} width="40%" style={{ marginBottom: 9 }}/>
                        <div className='digital-grid'>
                            <div className='digital-grid-item'>
                                <Skeleton animation="wave" height={60} width="50%" style={{ marginBottom: 9 }}/>
                                <Skeleton animation="wave" height={20} width="100%" />
                                <Skeleton animation="wave" height={20} width="50%"  style={{ marginBottom: 9 }}/>
                                <Skeleton animation="wave" height={50} width="30%" />
                            </div>
                            <div className='digital-grid-item'>
                                <Skeleton animation="wave" height={60} width="50%" style={{ marginBottom: 9 }}/>
                                <Skeleton animation="wave" height={20} width="100%" />
                                <Skeleton animation="wave" height={20} width="50%"  style={{ marginBottom: 9 }}/>
                                <Skeleton animation="wave" height={50} width="30%" />
                            </div>
                        </div>
                    </div>
                :forum_selection.map((data,i1)=>(
                    <div className='digital-section' key={i1}>
                        <h1 className='font-roboto'>{data.channel}</h1>
                        <p className='font-nunito'>Silahkan pilih kategori yang menarik untuk anda</p>
                        <div className='digital-grid'>
                            {data.forums.map((forum,i2)=>(
                                <div className='digital-grid-item' key={i2}>
                                    <div className='digital-title'>
                                        <p className='font-nunito'>{forum.forum.name}</p>
                                    </div>
                                    <div className='digital-desc'>
                                        <p className='font-nunito'>{forum.forum.description}</p>

                                    </div>
                                    {forum.isSelected?
                                        <div onClick={()=>selectSelection(i1,i2)} className='kategori-favorit-active'>
                                            <p className='font-nunito margin-0'>Kategori Favorit</p>
                                            <img src={Check}/> 
                                        </div>
                                    :
                                    <div onClick={()=>selectSelection(i1,i2)} className={'kategori-favorit'}>
                                        <p className='font-nunito margin-0'>Tambah Kategori Favorit</p>
                                    </div>}
                                </div>
                            ))}
                            
                        </div>
                    </div>
                ))}
               
                <br/>
                <div className='text-center'>
                    <button onClick={onLanjut} className='btn-forum'>
                        {general.isLoading?<CircularProgress style={{color:'white'}}  size={15} />:'Simpan'}
                    </button>
                </div>
            </div>
            <br/><br/>
        </div>
    )
}
